/**
 * The page's one call, kept out of the component.
 *
 * CLAUDE.md: components and hooks call the app's API layer, never axios directly. Most Gluon pages still
 * hold their own axios call; copying that would be copying the thing the rule names. The URL, the
 * parameter and the response shape live here, and the page renders.
 */
import axios from 'axios'
import type { BoxTruckPricingAnalytics } from '@numeo/types'
import { apiErrorMessage } from '@/api/errorMessage'

/** One of `ANALYTICS_WINDOW_DAYS`, which the server validates against the same constant. 0 is all time. */
export async function fetchBoxTruckPricingAnalytics(days: number, signal?: AbortSignal): Promise<BoxTruckPricingAnalytics> {
    try {
        const res = await axios.get<{ success: boolean; data: BoxTruckPricingAnalytics }>('/gluon/box-truck-pricing-analytics', { params: { days }, signal })
        return res.data.data
    } catch (error) {
        // `apiErrorMessage`, not another copy of this catch block — see `api/errorMessage.ts`.
        throw new Error(apiErrorMessage(error))
    }
}
